import { Launch } from '@mui/icons-material'
import { Card, CardContent, CardHeader, IconButton } from '@mui/material'
import dayjs from 'dayjs'
import RouterLink from '../../RouterLink'

export function TopGainersCardLayout(props: { content: React.ReactNode }) {
  return (
    <Card sx={{ height: 1 }}>
      <CardHeader
        title="Top gainers"
        subheader={dayjs().subtract(1, 'day').format('L')}
        action={
          <IconButton component={RouterLink} to={`top-gainers`}>
            <Launch />
          </IconButton>
        }
      />
      <CardContent>{props.content}</CardContent>
    </Card>
  )
}
